import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Observateurs from './Observateurs';
import { openObservateursDialog } from 'store/common/commonActions';

class ObservateursContainer extends React.Component {

    handleClick = () => {
        //if (this.props.reclamation.countObservateurs && this.props.reclamation.countObservateurs > 0)
            this.props.openObservateursDialog();
    }

    render() {
        return <Observateurs count={this.props.reclamation.countObservateurs} onClick={this.handleClick} />;
    }
}

ObservateursContainer.propTypes = {
    reclamation: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => ({
    openObservateursDialog: () => dispatch(openObservateursDialog())
});

export default connect(null, mapDispatchToProps)(ObservateursContainer);